// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material";
import { Box, Typography, Button } from "@mui/material";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { NotificationProvider } from "./context/NotificationContext";
import ProtectedRoute from "./utils/ProtectedRoute";
import { routesConfig } from "./config/routesConfig";
import AppLayout from "./layouts/AppLayout";
import Login from "./pages/Login";
import Error404 from "./pages/Error404";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', gap: 2 }}>
          <Typography variant="h6">เกิดข้อผิดพลาดที่ไม่คาดคิด</Typography>
          <Button variant="contained" onClick={() => window.location.reload()}>รีโหลดหน้า</Button>
        </Box>
      );
    }
    return this.props.children;
  }
}

function AppContent() {
  const theme = createTheme({
    typography: { fontFamily: "Sarabun" },
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          input: ({ ownerState }) => ({
            ...(!ownerState.multiline && {
              paddingTop: '6.5px',
              paddingBottom: '6.5px',
            }),
          }),
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Routes>
        {/* public */}
        <Route path="/login" element={<Login />} />

        {/* สร้าง route จาก config */}
        {routesConfig.map(r => (
          <Route
            key={r.path}
            path={r.path}
            element={
              <ProtectedRoute {...r.permission}>
                <AppLayout>
                  <r.component />
                </AppLayout>
              </ProtectedRoute>
            }
          />
        ))}

        {/* 404 */}
        <Route path="/error" element={<Error404 />} />
        <Route path="*" element={<Navigate to="/error" replace />} />
      </Routes>
    </ThemeProvider>
  );
}

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <CartProvider>
          <NotificationProvider>
            <ErrorBoundary>
              <AppContent />
            </ErrorBoundary>
          </NotificationProvider>
        </CartProvider>
      </AuthProvider>
    </Router>
  );
}
